import { Box } from "@mui/material";
import { RslS6Settings } from "../SettingsData";
import BaseSettingsDisplay from "./base/BaseSettingsDisplay";

const DungeonsShuffleSettings = () => {

    let setting = RslS6Settings.find(x => x?.name === "Dungeon Shuffle")

   
   
    
    return <Box>
            <BaseSettingsDisplay 
                setting={setting} 
            />
        </Box>
}

export default DungeonsShuffleSettings;